// extracted by mini-css-extract-plugin
export var animationContainer = "_h9-0";
export var asteriskIcon = "_h9-8";
export var conversationLeftSection = "_h9-4";
export var conversationListItem = "_h9-3";
export var conversationMiddleSection = "_h9-5";
export var conversationRightSection = "_h9-6";
export var detailsContent = "_h9-1";
export var listContainer = "_h9-7";
export var modalContent = "_h9-2";